const DataServices = [
    {
        image : 'images/our-projects.jpg',
        title : 'Projects',
        comment : 'Take a look at our inspiring landscaping, design, and horticultural projects from across Sydney.',
        ButtonTitle : 'All Projects',
        url : '/project-list'
    },
    {
        image : 'images/our-services.jpg',
        title : 'Services',
        comment : 'Discover what’s possible with a professional range of services and work that’s guaranteed.',
        ButtonTitle : 'View Services',
        url : '/services'
    },
    {
        image : 'images/aboutx.jpg',
        title : 'About',
        comment : 'We believe garden design is about understanding the corresponding relationships between spaces, shapes, materials and colour.',
        ButtonTitle : 'Find Out More',
        url : '/about',
    }

]


export const getDataAboutPage = [
    DataServices[0],
    DataServices[1]
]

export const getDataServicePage = [
    DataServices[0],
    DataServices[2]
]
export default DataServices;